import { render, staticRenderFns } from "./CommandCellTemplate.vue?vue&type=template&id=2136e754&"
import script from "./CommandCellTemplate.vue?vue&type=script&lang=js&"
export * from "./CommandCellTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports